import { Button, ButtonVariant } from '@/components/form/button';

export const FermentationActionButton = ({
  onClick,
  children,
}: {
  onClick?: () => void;
  children: JSX.Element;
}) => {
  return (
    <>
      <Button
        variant={ButtonVariant.Link}
        classnames="bg-white z-20 w-10 h-10 rounded-full flex items-center justify-center transition-all ease-in-out duration-300 hover:border-4"
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick();
        }}
      >
        {children}
      </Button>
    </>
  );
};
